module.exports = __webpack_public_path__ + "static/img/1008_small.6e42f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1008_small.png
// module id = +2WJ
// module chunks = 1